"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import { useAuthStore } from "@/stores/authStore";

export type Branch = {
  id: number;
  name: string;
  gstin?: string | null;
  bill_prefix?: string | null;
};

export function useBranches() {
  const token = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ["branches"],
    queryFn: async () => {
      const { data } = await api.get<{ branches: Branch[] }>("/api/branches");

      return data.branches;
    },
    enabled: Boolean(token),
  });
}
